export enum PaymentRequestTypeEnum {
  TIME_X_RATE = 'TIME_X_RATE',
  SPECIFY_AMOUNT = 'SPECIFY_AMOUNT',
  MILESTONE = 'MILESTONE',
}

export enum TimesheetTypeEnum {
  NONE = 'none',
  FILE = 'file',
  SHEET = 'sheet',
  TEXT = 'text',
  TIMESHEET = 'timesheet',
}

export enum MarketEnum {
  CANADA = 'ca',
}
